/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-useless-constructor */
import { useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { GridColumn, Grid } from '@progress/kendo-react-grid';
import { withState } from '../../../../components/common/grid/WrappedGrid';
import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import { API_URL } from '../../../../utils/constants';
import GridWrapper from '~/src/components/common/GridWrapper';
import createIcon from '../../../../static/img/createIcon.svg';

export default function ManufacturersList(): JSX.Element {
  const history = useHistory();
  const stateRef = useRef(null);
  const url = `${API_URL}/contractors/manufacturers/get`;
  const StatefullGrid = withState(Grid, url);

  const productNameCell = (row) => {
    const { dataItem } = row;

    return (
      <td>
        <Link to={`/manufacturers/edit/${dataItem.id}`}>{dataItem?.name}</Link>
      </td>
    );
  };

  return (
    <WhitePad>
      <TitleComponent
        title="Manufacturers"
        titleRight="Create"
        onRightHandler={(): void => history.push('/manufacturers/create')}
        iconRight={createIcon}
        titleLeft="Back"
        onLeftHandler={(): void => history.goBack()}
      />
      <GridWrapper>
        <StatefullGrid ref={stateRef}>
          <GridColumn field="name" title="Manufacturer Name" cell={(row) => productNameCell(row, stateRef)} />
        </StatefullGrid>
      </GridWrapper>
    </WhitePad>
  );
}
